import {REDIRECT_NEW_ACCOUNTS_TO_MOBILE_WEB_COLONIST_VERSION} from '@colonist/types'
import {ClientUserState} from './ClientUserState'
import {UIDeviceController} from './ui_html/UIDeviceController'
import {UIUrlController} from './ui_html/UIUrlController'

export class ClientPlatformRedirection {
    static handleAccountRedirection() {
        if(!this.shouldPerformAnyRedirection()) return

        const isGuestUser = !ClientUserState.userState?.isLoggedIn

        if(isGuestUser) {
            this.handleRedirectNewAccountsToMobileWeb()
            return
        }

        const colonistVersion = ClientUserState.userState?.colonistVersion
        const isNewUser = colonistVersion != undefined && colonistVersion >= REDIRECT_NEW_ACCOUNTS_TO_MOBILE_WEB_COLONIST_VERSION

        if(!isNewUser) return

        this.handleRedirectNewAccountsToMobileWeb()
    }

    private static isUserOnLandingPage(): boolean {
        // Should be similar logic in code/client/web/views/pages/ejs_shared/first-scene-detection.ejs
        if(!UIUrlController.isUrlPathRoot()) return false
        if(window.location.pathname.includes('/mobile')) return false
        if(ClientUserState.userState?.isLoggedIn) return false
        const hasCompletedOneGame = (ClientUserState.userState?.totalCompletedGameCount ?? 0) > 0
        if(hasCompletedOneGame) return false

        return true
    }

    private static shouldPerformAnyRedirection(): boolean {
        if(!UIDeviceController.isUserOnMobileWebBrowser()) return false
        if(UIDeviceController.isUserOnTabletDevice()) return false
        if(this.isUserOnLandingPage()) {
            const shouldRedirectToRoom = UIUrlController.getRoomIdFromUrl() != undefined
            return shouldRedirectToRoom
        }

        return true
    }

    private static isOnMobilePath(): boolean {
        return window.location.pathname.includes('/mobile')
    }

    private static handleRedirectNewAccountsToMobileWeb() {
        if(this.isOnMobilePath()) return
        const languagePrefix = UIUrlController.getLanguagePrefix()
        const newUrl = languagePrefix + '/mobile' + UIUrlController.getRelativeUrlWithoutLanguagePrefix()
        window.location.href = this.removeTrailingSlash(newUrl)
    }

    private static removeTrailingSlash(url: string): string {
        return url.replace(/\/([?#])/, '$1')
    }
}
